/** @jsxImportSource react */
import ArrowLink from '@react/shared/components/ArrowLink';
import Button from '@react/system/Button';
import { TOCS } from '@sly/core/constants/filters';
import { formatMoney } from '@sly/core/helpers/numbers';
import { useMemo } from 'react';

const PricingByRoomSize = ({
  pricingData,
  filters,
  locationText,
  onCtaClick,
}) => {
  const tocText = TOCS?.[filters?.toc]?.label?.toLowerCase();
  const pricingArray = useMemo(() => {
    if (!pricingData) return [];
    return Array.from(pricingData, ([key, value]) => ({
      roomSize: key,
      price: formatMoney(value),
      link: `/${filters?.toc}/${filters?.state}/${filters?.city}`,
      linkText: `See ${key} communities`,
    }));
  }, [filters?.city, filters?.state, filters?.toc, pricingData]);

  return (
    <div>
      {!!pricingArray?.length && (
        <div className='space-y-6'>
          <div className='font-t-xs-azo'>
            Your estimated average cost for {tocText} in {locationText}
          </div>
          <div className='grid gap-4 py-2 md:grid-cols-3'>
            {pricingArray.map((item) => {
              return (
                <div
                  key={item.roomSize}
                  className='grid items-center justify-between gap-1'
                >
                  <div className='font-b-s capitalize-first'>
                    {item.roomSize} size community
                  </div>
                  <div className='font-t-m-azo'>{item.price}/mo</div>
                  <ArrowLink
                    href={item.link}
                    className='font-b-s inline-block font-medium'
                  >
                    See all communities
                  </ArrowLink>
                </div>
              );
            })}
          </div>
          {onCtaClick && (
            <>
              <div className='space-y-2'>
                <h4 className='font-t-xs-azo'>What to do next?</h4>
                <p>
                  Get a list of communities based on your care needs and
                  preferences. Seniorly offers a free consultation with a local
                  senior living advisor who lives in your area and knows all the
                  information about senior living communities near you.
                </p>
              </div>
              <Button
                className='!h-max w-full md:w-max'
                variant='primary'
                onClick={() => onCtaClick()}
                id='talktoexpertbtn'
                eventProps={{
                  location: 'Cost Calculator',
                  converting: true,
                }}
              >
                Get a personalized list of options
              </Button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PricingByRoomSize;
